import { Navbar } from '@/components/layout/Navbar';
import { Heart, Target, Users, Sparkles } from 'lucide-react';
import ChildrenSilhouette from '@/components/shared/ChildrenSilhouette';

const About = () => {
  const features = [
    { icon: Target, title: '我们的使命', desc: '让每个人都能轻松规划完美的旅行，用AI技术降低旅行规划门槛，让旅行回归纯粹的快乐。' },
    { icon: Users, title: '服务理念', desc: '以用户体验为中心，提供智能化、个性化的旅行规划服务，成为你最懂你的旅行伙伴。' },
    { icon: Sparkles, title: '技术驱动', desc: '运用先进的AI技术，为用户生成专业、实用的旅行攻略，发现旅途中每一处美好。' },
  ];

  return (
    <div className="min-h-screen relative" style={{ background: 'linear-gradient(180deg, #101a30 0%, #162544 50%, #101a30 100%)' }}>
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 md:px-6 pt-28 pb-20 relative z-10">
        <div className="text-center mb-14" style={{ animation: 'rise .75s ease-out both' }}>
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-2xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, var(--glow), var(--mid))', boxShadow: '0 8px 28px rgba(61,130,176,0.35)' }}>
              <svg width="40" height="40" viewBox="0 0 48 48" fill="none">
                <defs><linearGradient id="abg" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#eef3f7" /><stop offset="100%" stopColor="#9ec8e0" /></linearGradient></defs>
                <path d="M6 32C10 22 16 18 24 18C32 18 38 22 42 32" stroke="url(#abg)" strokeWidth="2.4" strokeLinecap="round" fill="none" />
                <path d="M10 28C14 22 18 20 24 20C30 20 34 22 38 28" stroke="rgba(238,243,247,0.4)" strokeWidth="1.6" fill="none" />
                <path d="M24 18L14 8C14 8 18 6 24 6C30 6 34 8 34 8L24 18Z" fill="url(#abg)" />
                <circle cx="36" cy="10" r="2" fill="#d4a853" />
              </svg>
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold cb mb-4 is">关于我们</h1>
          <p className="text-lg cm max-w-lg mx-auto">西蒙的猫旅行日记是一款 AI 驱动的智能旅行规划助手，致力于让每一次旅行都充满意义</p>
        </div>

        <div className="frost p-10 mb-10" style={{ animation: 'rise .75s ease-out 0.1s both' }}>
          <div className="flex items-center gap-3 mb-6">
            <Heart className="w-6 h-6" style={{ color: '#f4a8c0' }} />
            <h2 className="text-2xl font-bold cb">品牌故事</h2>
          </div>
          <p className="cm leading-relaxed text-lg">一个人、一只猫、一颗想让旅行变简单的心，于是就有了这个小角落 🐱✨</p>
          <p className="cm leading-relaxed mt-4">我们相信，旅行不是打卡清单上的勾选项，而是与世界、与自己的深度对话。每一段旅程都值得被认真对待，每一个故事都值得被妥善保存。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {features.map((f, i) => (
            <div key={i} className="frost p-7" style={{ animation: `rise .75s ease-out ${0.2 + i * 0.1}s both` }}>
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style={{ background: 'rgba(106,179,214,0.15)', border: '1px solid rgba(106,179,214,0.2)' }}>
                <f.icon className="w-7 h-7 cg" />
              </div>
              <h3 className="font-bold text-lg cb mb-2">{f.title}</h3>
              <p className="text-[13px] cm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="relative overflow-hidden rounded-3xl" style={{ minHeight: 160 }}>
          <ChildrenSilhouette className="absolute inset-0 w-full h-full opacity-60" />
          <div className="relative z-10 p-10 text-center">
            <h3 className="text-2xl font-bold cb mb-3">加入我们的旅程</h3>
            <p className="cm max-w-md mx-auto text-sm">无论你是旅行爱好者、摄影达人，还是想要探索世界的冒险家，西蒙的猫都将是你最好的旅行伙伴</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
